<template>
    <SemesterRequired>
        <template #no-semester>
            <i>
                No semester is in progress.
            </i>
        </template>
        <template #not-authorized>
            <i>You do not have access to semester information for this group.</i>
            <hr/>
        </template>
        <template #semester-in-progress="{ semester }">
            <b>Current Semester</b>
            <h2>{{ semester.label }}</h2>
            <div
                class="text-center mt-3"
            >
                <router-link
                    v-if="settings.ALLOW_REGISTRATION"
                    class="sc-btn pill"
                    :to="{ name: 'register' }"
                >
                    Register
                    <font-awesome-icon
                        icon="arrow-right"
                        class="ml-2"
                    ></font-awesome-icon>
                </router-link>
            </div>
        </template>
    </SemesterRequired>
</template>
<script>
import SemesterRequired from '@/components/authz/SemesterRequired.vue';
import { mapState } from 'vuex';
    
export default {
    components: { SemesterRequired },
    computed: mapState(["settings"])
}
</script>